/** Joins class names, dropping the falsy ones. Local to the parts so they import nothing from the older UI layer. */
export function cx(...parts: Array<string | number | boolean | null | undefined>): string {
  return parts.filter((p): p is string => typeof p === "string" && p.length > 0).join(" ");
}
